import { html } from "lit-html"
import { virtual, useEffect, useRef, useState } from "haunted"
import { ref } from "../directives"
import { onDropdownKeydown } from "../utils"

const ActionMenu = virtual(({ children }) => {
  const menuRef = useRef(null)
  const [active, setActive] = useState(false)

  useEffect(() => {
    const handleDocClick = (event) => {
      if (
        !(menuRef.current && menuRef.current.contains(event.target)) &&
        active
      ) {
        setActive(false)
      }
    }

    document.addEventListener("click", handleDocClick, false)

    return () => {
      document.removeEventListener("click", handleDocClick)
    }
  }, [active, menuRef])

  return html`<div class="dropdown ${active ? "expanded" : ""}" ?ref=${ref(
    menuRef
  )} @keydown=${(e) => {
    if (["Enter", "Space"].includes(e.code)) e.stopPropagation()
    onDropdownKeydown(e, menuRef ? menuRef.current : null)
    if (menuRef)
      setActive(
        menuRef.current
          .querySelector("button")
          .getAttribute("aria-expanded") === "true"
      )
  }}>
        <div class="dropdown-trigger">
          <button
            type="button"
            class="button p-0 min-w-44 w-10 h-10 ${
              active ? `bg-blue text-white focus:text-white` : ``
            }"
            aria-label="Actions"
            aria-expanded=${active.toString()}
            @click=${(event) => {
              event.stopPropagation()
              setActive(!active)
            }}
            @keydown=${(event) => {
              if (["Enter", "Space"].includes(event.code))
                event.stopPropagation()
            }}
          >
            <i class="cb fa-overflow w-full h-full ${
              active ? `text-white` : ``
            }"></i>
          </button>
        </div>
        <div class="dropdown-menu right-0 left-auto" role="menu">
          <div class="dropdown-content">
            ${children}
          </div>
        </div>
      </div>
    </div>`
})

export default ActionMenu
